import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

const LANGUAGES = [
  { code: 'tr', name: 'Turkce', native: 'TR' },
  { code: 'en', name: 'English', native: 'EN' },
  { code: 'fr', name: 'Francais', native: 'FR' },
  { code: 'es', name: 'Espanol', native: 'ES' },
  { code: 'ar', name: 'Arabic', native: 'AR' },
  { code: 'fa', name: 'Dari', native: 'FA' },
];

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('astravolt_lang') || 'tr';
  });

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      if (!value) return key;
      value = value[k];
    }
    return value || key;
  }, [language]);

  const isRTL = language === 'ar' || language === 'fa';

  useEffect(() => {
    localStorage.setItem('astravolt_lang', language);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language, isRTL]);

  const contextValue = useMemo(() => ({
    language, setLanguage, t, isRTL, LANGUAGES
  }), [language, t, isRTL]);

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
